<!-- Modal Container -->
<template>
  <transition name="modal-fade" class="modal-fade">
    <div class="modal-backdrop">
      <form action="#"  method="post">
      <div class="opportunity-status-alert-modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <slot name="header">           
            <i aria-hidden="true" class="fa fa-exclamation-triangle alert-icon"></i>&nbsp;&nbsp;{{alertTitle}}
            <div class="closeButton">
              <!-- <button type="button" class="btn" @click="close">Close</button> -->
            </div>
          </slot>
        </header>
        <section class="opportunity-status-alert-modal-body">
          <div class="row">
            <div class="warningMessage">{{warningMessage}}</div>
            </div>        
        </section>
        <footer class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-primary" @click="close">Close</button>
              <!-- <input type="submit" class="btn btn-primary" value="Yes, Proceed"> -->
          </slot>
        </footer>
      </div>
      </form>
    </div>
  </transition>
  <!-- Modal Container end -->
</template>
<script>
  export default {
    name: 'modal',
    props: [ 'alertTitle', 'opportunityStatus', 'warningMessage' ],
    data () {
      return {
        title: 'Opportunity Report'
      }
    },
    methods: {
      close () {
        console.log('closing the modal')
        this.submitted = false
        this.$emit('close')
      }
    }
  }
</script>
<style>
/* @import './../../assets/admin-lte.css'; */
</style>
<style>
.alert-icon {
  color: red;
    font-size: 26px;
}
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .opportunity-status-alert-modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);    
    height:200px;    
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: inline-block;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    font-size: 18px;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .opportunity-status-alert-modal-body {
    position: relative;
    padding: 20px 10px;
    min-height: 70px;    
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #0D9488;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #0D9488;
    border: 1px solid #0D9488;
    border-radius: 2px;
  }
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
  .closeButton {
    position:absolute;
    left:92%;
    top:-1%;
    font-weight: bold;
  }
  .text-red {
    color: red
  }
  .text-green {
    color: green
  }
  .font-size20px {
    font-size: 20px;
  }
  .warningMessage {
    word-wrap: break-word;
    padding-left: 60px;
    padding-right: 60px;
  }
</style>


// WEBPACK FOOTER //
// opportunityStatusAlert.vue?29709b6a